
import React from "react";
import { useParams } from 'react-router-dom'
import { Helmet } from "react-helmet-async";
import { copy } from 'copy-anything'
import {
  Button,
  Container,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import ProductLoop from "components/MyPackage/ProductLoopCategory.js"
import PriceFilter from "components/Filter/PriceFilter.js"
function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}
class MyPackageCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPerPage: 10,
      showTotal: 10,
      products: [],
      productsOriginal: [],
      categories: [],
      sortData: "",
      filterModal: false,
      priceFilter: {
        selected: [0, 500],
        min: 0,
        max: 500,
      },
      categoryName: ".",
      selectedid: null,
      productType: null,
      productCat: [],
      productPackage: null,
      package: null,
      minPrice: null,
      maxPrice: null,
      stepID: 0,
      tag: []

    }
    //this.myRef = React.createRef()
    this.exportRef = React.createRef();
  }
  loadMore = () => {
    let newLoadReq = this.state.showTotal + this.state.showPerPage;
    if (this.state.products.length >= this.state.showTotal) {
      this.setState({
        showTotal: newLoadReq
      })
    }


  }
  toggleFilterModal = () => {
    this.setState({
      filterModal: !this.state.filterModal
    });
  }
  docallmountFunction = async (type, packagid, productCat, minPrice, maxPrice) => {
    await this.loadPackage(parseInt(packagid))
    const cleanArr = productCat.filter(item => item && item.toString().trim() !== "");
    if (type.toLowerCase() === 'card') {

      if (cleanArr.length) {

        await this.loadProduct(productCat, "card", minPrice, maxPrice)
      }


    }
    if (type.toLowerCase() === 'accessories') {
      if (cleanArr.length) {
        await this.loadProduct(productCat, "accessories", minPrice, maxPrice)
      }
    }


    window.scrollTo(0, 0);
  }
  async componentDidMount() {
    let { id } = this.props.params;
    let splitid = atob(id).split('*')
    this.state.productType = splitid[0].toLowerCase()
    this.state.productCat = splitid[1].split(',')
    this.state.productCat.forEach((item) => {
      item = item.toString()
    })
    this.state.minPrice = parseInt(splitid[3])
    this.state.maxPrice = parseInt(splitid[4])
    this.state.stepID = parseInt(splitid[5])
    this.state.tag = splitid[6] ? splitid[6].split(',') : [];
    this.setState({
      productType: this.state.productType,
      productCat: this.state.productCat,
      minPrice: this.state.minPrice,
      maxPrice: this.state.maxPrice,
      stepID: this.state.stepID
    })
    this.docallmountFunction(splitid[0], splitid[2], this.state.productCat, this.state.minPrice, this.state.maxPrice)

  }
  loadPackage = async (id) => {
    const response = await fetch('../API/weddingPackage.json', {
    })
    const responseJson = await response.json();

    let tempData = responseJson;
    tempData.forEach((item, index) => {
      item.checked = false;
      if (item.id === parseInt(id)) {
        this.state.package = item
        this.setState({
          package: this.state.package,
        })
      }
    })



  }
  loadProduct = async (ids, type, min, max) => {
    try {
      // Pick API based on type
      let apiURL = '';
      if (type === 'card') {
        apiURL = '../API/products.json';
      }
      if (type === 'accessories') {
        apiURL = '../API/accessories.json';
      }

      // Fetch data
      const response = await fetch(apiURL);
      const tempData = await response.json();

      let filterProduct = [];

      tempData.forEach((item) => {
        // normalize tags (support both "tag" and "tags")
        // if (item.tags) {
        //   console.log("item.tags", item.tags);
        // }
        const rawTags = item.tags || item.tag || [];
        const tags = Array.isArray(rawTags)
          ? rawTags
          : String(rawTags).split(',').map(c => c.trim());

        // normalize categories
        const rawCat = item.category || [];
        const categories = Array.isArray(rawCat)
          ? rawCat
          : String(rawCat).split(',').map(c => c.trim());

        // parse to integers for comparison
        const productCatInt = this.state.productCat.map(c => parseInt(c));
        console.log('productCatInt', productCatInt);
        console.log('item.category', categories);
        const packageTagInt = (this.state.tag || []).map(c => parseInt(c));
        const itemTagsInt = tags.map(c => parseInt(c));

        const matchCat = categories.some(cat => productCatInt.includes(parseInt(cat)));

        let match = false;
        if (packageTagInt.length > 0) {
          console.log('category and tag match');
          // 🔹 only check tag match if state.tag has values
          const matchTag = itemTagsInt.some(tag => packageTagInt.includes(tag));
          match = matchCat && matchTag;
        } else {
          match = matchCat;
          console.log(matchCat)
        }

        if (
          match &&
          parseInt(item.price) >= min &&
          parseInt(item.price) <= max &&
          !item.outOfstock
        ) {
          filterProduct.push(item);
        }
      });




      // Update state properly
      this.setState({
        products: filterProduct,
        productsOriginal: copy(filterProduct)
      });

      console.log("my package products", filterProduct);
    } catch (error) {
      console.error(error);
    }
  };

  loadCategories = (id) => {
    fetch('../API/accessoriesCategory.json', {
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let tempData = responseJson;
        tempData.forEach((item, index) => {
          item.checked = false;
          if (item.id === id) {
            this.state.categoryName = item.name
            this.state.selectedid = index
          }
        })
        this.state.categories = tempData
        this.setState({
          selectedid: id
        })
        this.setState({
          categories: this.state.categories,
          categoryName: this.state.categoryName,
          selectedid: this.state.selectedid
        })
      })
      .catch(error => {
        console.log(error);
      })
  }
  changeSortData = (e) => {
    let val = e.target.value;
    let name = e.target.name;
    this.state.sortData = val;
    this.setState({
      sortData: this.state.sortData
    })

    this.getFilterDataProductByCategory()
    setTimeout(() => {
      this.getSOrtData()
    }, 10);

  }
  getSOrtData = () => {
    let val = this.state.sortData
    let product = this.getUniqueItem(this.state.products)
    console.log(product)
    if (val === 'lh') {
      this.setState({
        products: this.sortPriceLowToHigh(product)
      })
    }
    else if (val === 'hl') {
      this.setState({
        products: this.sortPriceHighToLow(product)
      })
    }
    else {
      this.setState({
        products: product
      })
    }

  }
  sortPriceLowToHigh = (data) => {
    return data.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
  }
  sortPriceHighToLow = (data) => {
    return data.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
  }
  applyFilterPrice = (data) => {
    this.setState({
      priceFilter: data
    })

  }
  applyFilter = (data) => {
    this.setState({
      categories: data
    })
    // this.getFilterDataProductByCategory()
  }
  getFilterDataProductByCategory = () => {
    let minPrice = this.state.minPrice;
    let maxPrice = this.state.maxPrice;
    let freshProduct = copy(this.state.productsOriginal);
    let filterProduct = [];

    freshProduct.forEach((item) => {
      // normalize tags (support both "tag" and "tags")
      const rawTags = item.tags || item.tag || [];
      const tags = Array.isArray(rawTags)
        ? rawTags
        : String(rawTags).split(',').map(c => c.trim());

      // normalize categories
      const categories = Array.isArray(item.category)
        ? item.category
        : String(item.category).split(',').map(c => c.trim());

      // parse to integers
      const productCatInt = this.state.productCat.map(c => parseInt(c));
      const packageTagInt = (this.state.tag || []).map(c => parseInt(c));
      const itemTagsInt = tags.map(c => parseInt(c));

      // check category match
      const matchCat = categories.some(cat => productCatInt.includes(parseInt(cat)));

      let match = false;
      if (packageTagInt.length > 0) {
        // 🔹 require both category + tag
        const matchTag = itemTagsInt.some(tag => packageTagInt.includes(tag));
        match = matchCat && matchTag;
      } else {
        // 🔹 only category
        match = matchCat;
      }

      if (
        match &&
        parseInt(item.price) >= minPrice &&
        parseInt(item.price) <= maxPrice &&
        !item.outOfstock
      ) {
        filterProduct.push(item);
      }
    });

    this.state.products = this.getUniqueItem(filterProduct);
    this.setState({
      products: this.state.products
    });
  };

  onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  }
  getUniqueItem = (data) => {
    const keys = ['id', 'name'];
    const filteredData = data.filter((value, index, self) =>
      self.findIndex(v => keys.every(k => v[k] === value[k])) === index
    )
    return filteredData
  }
  getFilterData = () => {
    this.getFilterDataProductByCategory()
    setTimeout(() => {
      this.getSOrtData()
    }, 10);
    this.toggleFilterModal()
  }
  resetFilterData = () => {
    this.state.priceFilter.min = 0;
    this.state.priceFilter.max = 500
    this.state.priceFilter.selected = [0, 500]
    this.setState({
      priceFilter: this.state.priceFilter
    })
    setTimeout(() => {
      this.getFilterDataProductByCategory()
    }, 5)
    setTimeout(() => {
      this.getSOrtData()
    }, 10);
    this.toggleFilterModal()
  }
  render() {
    let allproduct = this.state.products.length;


    let showTotal = this.state.showTotal;
    let ifloadMore = false;
    if (allproduct > showTotal) {
      ifloadMore = true
    }
    return (

      <>

        <DemoNavbar />
        <main ref="main">
          <section
            style={{ backgroundImage: "url(../../images/inner-banner-bg.webp)", backgroundPosition: "center", backgroundSize: "cover" }}
            className="section pageTitleBG">
            <div className="row m-0">
              <div className="col-12">
                <h1 style={{ fontWeight: "500" }} className="h1 text-center text-uppercase mb-0">My Package <i class="fas fa-arrow-right-long"></i> {this.state.productType}</h1>
                <div>

                </div>
              </div>
            </div>
          </section>

          <section className="section ">
            <Container fluid>
              <div className="row">
                <div className="col-12">
                  <div className="row align-items-center mb-3">
                    <div className="col-6 col-lg-3 col-xl-3 col-md-4 ">
                      <div class="form-floating ">
                        <select value={this.state.sortData} name="sortData" onChange={(e) => this.changeSortData(e)} className="form-select">
                          <option value="">Default</option>
                          <option value="lh">Price : low to high</option>
                          <option value="hl">Price : high to low</option>
                        </select>
                        <label for="floatingInput">Sorting</label>
                      </div>
                    </div>
                    <div className="col-12 col-lg-3 col-xl-3 col-md-2 d-none d-lg-block d-xl-block d-md-block"></div>
                    <div className="col-12 col-lg-3 col-xl-3 col-md-2 d-none d-lg-block d-xl-block d-md-block"></div>
                    <div className="col-6 col-lg-3 col-xl-3 col-md-4 text-end">
                      {/* <button onClick={this.toggleFilterModal} className="btn btn-lg btn-outline-danger "><i class="fa-solid fa-filter"></i> Filter</button> */}
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <ProductLoop stepID={this.state.stepID} productCat={this.state.productCat} productType={this.state.productType} showPerPage={this.state.showTotal} data={this.state.products} />
                </div>
                {ifloadMore &&
                  <div className="col-12 text-center">
                    <button className="btn btn-danger btn-lg" onClick={(e) => this.loadMore()}>Load More</button>
                  </div>
                }

              </div>
            </Container>
          </section>
        </main>
        <SimpleFooter />
        <Modal centered isOpen={this.state.filterModal} toggle={this.toggleFilterModal} className={this.props.className}>
          <ModalHeader toggle={this.toggleFilterModal}>Filter</ModalHeader>
          <ModalBody>
            {/* <div className="mb-3">
              <CategoryFilter applyFilter={this.applyFilter} data={this.state.categories} />
            </div> */}
            <div>
              <PriceFilter data={this.state.priceFilter} applyFilterPrice={this.applyFilterPrice} />
            </div>
          </ModalBody>
          <ModalFooter>

            <Button color="danger" onClick={this.getFilterData}>Apply Filter</Button>
            <Button color="dark" onClick={this.resetFilterData}>Reset</Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
export default withParams(MyPackageCategory);
